/* generated by generate-service-wrappers.js -- do not edit */
import { ContentService as GeneratedContentService } from '../generated/services/ContentService';

export class ContentService extends GeneratedContentService {
  /** @deprecated Use getContent20 instead */
  static queryV20 = GeneratedContentService.getContent20;
  /** @deprecated Use getContentItemById20 instead */
  static byIdV20 = GeneratedContentService.getContentItemById20;
  /** @deprecated Use getContentItemByPath20 instead */
  static byRouteV20 = GeneratedContentService.getContentItemByPath20;
  /** @deprecated Use getContentItems20 instead */
  static itemsV20 = GeneratedContentService.getContentItems20;
}
